import { QueryClientProvider } from "@tanstack/react-query";
import React, { ReactNode } from "react";

import { queryClient } from "src/queryClient";

type Props = {
  children: ReactNode;
};

export const QueryProvider: React.FC<Props> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
